import CustomSelect from "components/customs/dropdown";
import SearchBarComponent from "components/customs/searchbarV2";
import { dropdownSelectStyle } from "constants/style";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { accountRoles } from "utility/constants";
import { hasPermission } from "utility/helpers";
import { UserPlus } from "react-feather";
import { AddButton } from "assets/js/Styles";
import { ADD_ACTION } from "constants/actions";

const StyledAddButton = styled(AddButton)`
  width: 130px;
  background: ${({ theme }) => theme.colors.buttonBlue};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const AddButtonText = styled.span`
  padding-left: 8px;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.63px;
`;

const AddAccountSection = styled.div`
  display: flex;

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    a {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  margin-top: 44px;
`;

const Container = styled.div`
  padding: 0;
  display: grid;
  gap: 16px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 130px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr !important;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const SearchbarWrapper = styled.div`
  width: 100%;
  position: relative;

  input {
    border: 2px solid ${({ theme }) => theme.colors.black60};
    background: white;
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const AccountFilters = ({
  setSelectedAgency,
  selectedAgency,
  agencies,
  selectedRole,
  setSelectedRole,
  onChangeSearch,
  tableOption,
}) => {
  return (
    <Wrapper>
      <Container>
        <CustomSelect
          isSearchable={false}
          onChange={(option) => {
            setSelectedAgency(option);
          }}
          placeholder="Agency"
          options={agencies}
          value={selectedAgency}
          styles={dropdownSelectStyle}
          getOptionLabel={(option) => {
            return option?.name;
          }}
          isClearable
          isDisabled={tableOption?.isLoading}
        />

        <CustomSelect
          isSearchable={false}
          onChange={(option) => {
            setSelectedRole(option);
          }}
          placeholder="Role"
          options={accountRoles}
          value={selectedRole}
          styles={dropdownSelectStyle}
          getOptionLabel={(option) => {
            return option?.label;
          }}
          isClearable
          isDisabled={tableOption?.isLoading}
        />

        <SearchbarWrapper>
          <SearchBarComponent
            onChangeSearch={onChangeSearch}
            isDisabled={tableOption?.isLoading}
          />
        </SearchbarWrapper>

        <AddAccountSection>
          {hasPermission("user-create") && (
            <Link
              to="/add-account"
              state={{
                action: ADD_ACTION,
              }}
            >
              <StyledAddButton>
                <UserPlus size={24} />
                <AddButtonText>{"Add"}</AddButtonText>
              </StyledAddButton>
            </Link>
          )}
        </AddAccountSection>
      </Container>
    </Wrapper>
  );
};

export default AccountFilters;
